import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { HighStockChartComponent } from './high-stock-chart/high-stock-chart.component';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.sass']
})
export class ChartsComponent implements OnInit {
    //inputs from root component AppComponent
    @Input()
    private selectedPeriod: number;
    @Input()
    private selectedBaseTemp: number;
    @Input()
    private selectedLatlng: string;
    @Input()
    private variable: string;
    @Input()
    private unit: string;
    @Output()
    private chartReady: EventEmitter<boolean> = new EventEmitter<boolean>();
    private highstockLoaded = false;

  constructor() { }

  ngOnInit() {
  }

  onHighStockLoaded(message: boolean) {
      this.highstockLoaded = message;
      this.chartReady.emit(true);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/charts/charts.component.ts